import { useEffect, useState, type ReactNode } from 'react';
import styled from 'styled-components';

// Hook genérico de carga. Reejecuta cuando cambian las deps.
export function useAsync<T>(loader: () => Promise<T>, deps: unknown[]) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    loader()
      .then((d) => alive && setData(d))
      .catch((e) => alive && setError(e instanceof Error ? e.message : 'Error'))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, deps);

  return { data, error, loading };
}

const Center = styled.div`
  padding: 48px 16px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
`;

// Renderiza children solo cuando hay datos; muestra carga/error mientras tanto.
export function Async<T>({
  state,
  children,
}: {
  state: { data: T | null; error: string | null; loading: boolean };
  children: (data: T) => ReactNode;
}) {
  if (state.loading && !state.data) return <Center>Cargando…</Center>;
  if (state.error && !state.data) return <Center>⚠️ {state.error}</Center>;
  if (!state.data) return <Center>Sin datos</Center>;
  return <>{children(state.data)}</>;
}
